import { VisibilityOutlined } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import dayjs from 'dayjs';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Facture from '../../../Components/Docs/Facture';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import { statutPaiementEnum } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
// import { getLastWorkingDayOfMonth } from '../../../Utils/getCalendarMonthMatrix';
import { getNomPrenomClearFromPersoData, searchLabelInEnumByValue, sortDate } from '../../../Utils/utils';
import { getMontatantTTC } from '../../../Utils/utilsCraX';
import HeaderAllFacture from './HeaderAllFacture';

const AllRegularisationExpert = () => {
    const { addEuro4Decimal } = useNumberFormatting();
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const { setBackdropOpen} = useUtilities();
    const role=useRole();
    const factureColumns4Expert = [
        {
            field: 'refFactureExpert',
            title: i18n.t('Réf. Facture'),
            render:  rowData => (
                <Button
                    variant='text'
                    onClick={()=> {
                        Promise.resolve().then(() => {
                            setRowSelected(rowData);
                            setOpen(true);
                        }).then(() => setOpen(true));
                    }}
                >
                    {rowData?.refFactureExpert}
                </Button>
            )
        },
        {
            field: 'eye',
            title: i18n.t('Option'),
            render: rowData =>{
                return (
                    <IconButton
                        onClick={() => {
                            if(rowData?.isCraOrCraX=='craXId')
                                navigate(`/${role}/RegularizationPC`, {state: {rowData} });
                            else
                                navigate(`/${role}/NormalRegularization`, {state: {rowData} });
                        }}
                    >
                        <VisibilityOutlined />
                    </IconButton>
                );
            },
        },
        {
            field: 'dateEmission',
            title: i18n.t('Date d\'émission'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.dateEmission),
        },
        {
            field: 'nomClient',
            title: i18n.t('Nom du Client'),
        },
        ...(role=='esn' ?
            [{
                field: 'nomExpert',
                title: i18n.t('Nom de l\'expert'),
            }]:[]
        ),
        {
            field: 'refCra',
            title: i18n.t('Réf.CRA'),
        },
        {
            field: 'intituleMission',
            title: i18n.t('Intitulé de la mission'),
        },
        {
            field: 'statutPaiementExpert',
            title: i18n.t('Statut paiement'),
        },
        {
            field: 'datePaiementExpert',
            title: i18n.t('Date Paiement/Expert'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.datePaiementExpert)
        },
        {
            field: 'periode',
            title: i18n.t('Période'),
            //render:  rowData =>
            //    searchLabelInEnumByValue(MonthsString,(rowData?.periode)),
        },
        {
            field: 'dateEcheance',
            title: i18n.t('Date d\'échéance'),
        },
        {
            field: 'nbJour',
            title: i18n.t('Nb de jours'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.nbJour,'j');
            }
        },
        {
            field: 'tjExpert',
            title: i18n.t('Taux journalier HT'),
            render:  rowData =>
                addEuro4Decimal(rowData?.tjExpert)
        },
        {
            field: 'totalHTExpert',
            title: i18n.t('Total HT'),
            render:  rowData =>
                addEuro4Decimal(rowData?.totalHTExpert)
        },
        {
            field: 'tvaExpert',
            title: i18n.t('TVA appliquée'),
            render:  rowData =>
                addEuro4Decimal(rowData?.tvaExpert,' %'),
        },
        {
            field: 'totalTTCExpert',
            title: i18n.t('Total TTC'),
            render:  rowData =>
                addEuro4Decimal(getMontatantTTC(rowData?.totalHTExpert, rowData?.tvaExpert )),
        },
        {
            field: 'respOperationnel',
            title: i18n.t('Resp.Opérationnel'),
        },
        {
            field: 'chargeRecrutement',
            title: i18n.t('Chargé de recrutement'),
        },
        ...(role=='esn' ?
            [{
                field: 'Commercial',
                title: i18n.t('commercial ESN'),
            }]:
            []
        ),
    ];

    const axiosPrivate = useAxiosPrivate();
    const [factureRows, setFactureRows] = useState([]);
    const [rowselected, setRowSelected] = useState();
    const [url, setUrl] = useState('');
    const [open, setOpen] = useState(false);
    const searchParams = new URLSearchParams(location.search);
    const [filtreFactureExpertNonPaye, setFiltreFactureExpertNonPaye] = useState(searchParams.get('filtre') === 'true');
    const [selectedRow, setSelectedRow] = React.useState(null);

    useEffect(() => {
        const currentUrl = window.location.href;
        setUrl(currentUrl);
    }, [location]);

    useEffect(() => {
        if(url && !url.toLowerCase().includes('filtrefactureexpertnonpaye')  ){
            setFiltreFactureExpertNonPaye(false);
        }
    }, [url]);

    useEffect(() => {
        getMyRegularisations();
    }, [filtreFactureExpertNonPaye]);

    useEffect(() => {
        if(role)
            getMyRegularisations();
    }, [role]);
    //=============================================================================

    const getMyRegularisations = async () => {
        setBackdropOpen(true);
        const endpoint = role === 'esn'
            ? '/facture/getMyRegularisations/?isAchat=false'
            : '/facture/getMyRegularisations/';
        try {
            const response = await axiosPrivate.get(endpoint, {
                // signal: controller.signal
            });

            let listRegularisation = await response.data;
            let Array1=[];
            if(filtreFactureExpertNonPaye){
                listRegularisation?.forEach(regularisation => {
                    const isCraOrCraX = regularisation?.nbrUnite ? 'craId' : 'craXId';
                    // 4 BackOffice
                    if((regularisation?.statutFacture=='genere'||regularisation?.statutFactureX=='genere')&&(regularisation?.statutPaimentExpert=='nonPaye')){
                        Array1.push({
                            isCraOrCraX,
                            'id': regularisation?._id,
                            //'refFactureExpert': regularisation?.nbrUnite ? regularisation?.regularisationId + 'E' : regularisation?.regularisationXId + 'E',
                            'refFactureExpert':regularisation?.refFacture+'E',
                            'refCra': regularisation?.[isCraOrCraX]?.[isCraOrCraX],
                            'refClient': regularisation?.[isCraOrCraX]?.missionId?.companyDataId?.clientId ?? regularisation?.[isCraOrCraX]?.missionId?.esnId?.esnId,
                            'nomClient': regularisation?.[isCraOrCraX]?.missionId?.companyDataId?.profileEntreprise?.nom ?? regularisation?.[isCraOrCraX]?.missionId?.esnId?.profileEntreprise?.nom,
                            'nomExpert':getNomPrenomClearFromPersoData(regularisation?.[isCraOrCraX]?.missionId?.expertId?.persoData),
                            'intituleMission': regularisation?.[isCraOrCraX]?.missionId?.titre,
                            'dateValidationCra': Date(regularisation?.[isCraOrCraX]?.DateVC) > Date(regularisation?.[isCraOrCraX]?.DateVE) ? formatDateJJMMYYYY(regularisation?.[isCraOrCraX]?.DateVC) : formatDateJJMMYYYY(regularisation?.[isCraOrCraX]?.DateVE),
                            'dateEmission': formatDateJJMMYYYY(regularisation?.dateEmission),
                            'Date':regularisation?.dateEmission, // champ spécifie le tri
                            'Statut': regularisation?.nbrUnite ? regularisation?.statutFacture : regularisation?.statutFactureX,
                            //'periode':regularisation?.[isCraOrCraX]?.month,
                            'periode':
                                dayjs(new Date(regularisation?.[isCraOrCraX]?.year, regularisation?.[isCraOrCraX]?.month-1)).locale('fr').format('MMMM YYYY'),
                            'dateEcheance':formatDateJJMMYYYY(moment(regularisation?.dateEmission).add('days',regularisation?.delaiPaiement)),
                            // 'dateEcheance':formatDateJJMMYYYY(moment(getLastWorkingDayOfMonth(
                            //     dayjs(new Date(regularisation?.[isCraOrCraX]?.year, regularisation?.[isCraOrCraX]?.month-1)).locale('fr').format('YYYY'),
                            //     dayjs(new Date(regularisation?.[isCraOrCraX]?.year, regularisation?.[isCraOrCraX]?.month-1)).locale('fr').format('MM'),
                            //     (regularisation?.[isCraOrCraX]?.missionId?.companyDataId?.profileEntreprise?.localisation?.split('/')?.pop()||'fr'))).add('days',regularisation?.delaiPaiement)),
                            'statutPaiementExpert':i18n.t(searchLabelInEnumByValue(statutPaiementEnum,regularisation?.statutPaimentExpert)),
                            'nbJour':regularisation?.nbrUnite,
                            'tjExpert':regularisation?.[isCraOrCraX]?.tj,
                            'tvaExpert':regularisation?.tva ?? regularisation?.[isCraOrCraX]?.missionId?.esnExpertOwnerId?.donneeFacturation?.tauxTva ?? regularisation?.[isCraOrCraX]?.missionId?.expertId?.entreprise?.tauxTva,
                            'datePaiementExpert':regularisation?.datePaimentExpert,
                            'totalAstreinte':regularisation?.totalAstreintes??'--',
                            'totalHnoClient':regularisation?.totalHnosClient??'--',
                            'totalHnoExpert': regularisation?.totalHnos??'--',
                            'totalNotesFrais': regularisation?.totalNotesFrais??'--',
                            'totalHTExpert':regularisation?.montantTotal,

                            'hnos':regularisation?.hnos,
                            'astreintes':regularisation?.astreintes,
                            'notesFrais':regularisation?.notesFrais,

                            'respOperationnel':getNomPrenomClearFromPersoData(regularisation?.[isCraOrCraX]?.bdcId?.responsableOperationnelId?.persoData ?? regularisation?.[isCraOrCraX]?.bdcId?.responsableOperationnelEsnId?.persoData),
                            'chargeRecrutement':getNomPrenomClearFromPersoData(regularisation?.[isCraOrCraX]?.bdcId?.backOfficeId?.persoData),
                            'Commercial':getNomPrenomClearFromPersoData(regularisation?.[isCraOrCraX]?.bdcId?.collaboratorEsnExpertId?.persoData),
                            ...regularisation
                        });
                    }
                });
            }
            else{
                listRegularisation?.forEach(regularisation => {
                    const isCraOrCraX = regularisation?.nbrUnite ? 'craId' : 'craXId';
                    // 4 BackOffice
                    Array1.push({
                        isCraOrCraX,
                        'id': regularisation?._id,
                        //'refFactureExpert': regularisation?.nbrUnite ? regularisation?.regularisationId + 'E' : regularisation?.regularisationXId + 'E',
                        'refFactureExpert':regularisation?.refFacture+'E',
                        'refCra': regularisation?.[isCraOrCraX]?.[isCraOrCraX],
                        'refClient': regularisation?.[isCraOrCraX]?.missionId?.companyDataId?.clientId ?? regularisation?.[isCraOrCraX]?.missionId?.esnId?.esnId,
                        'nomClient': regularisation?.[isCraOrCraX]?.missionId?.companyDataId?.profileEntreprise?.nom ?? regularisation?.[isCraOrCraX]?.missionId?.esnId?.profileEntreprise?.nom,
                        'nomExpert':getNomPrenomClearFromPersoData(regularisation?.[isCraOrCraX]?.missionId?.expertId?.persoData),
                        'intituleMission': regularisation?.[isCraOrCraX]?.missionId?.titre,
                        'dateValidationCra': Date(regularisation?.[isCraOrCraX]?.DateVC) > Date(regularisation?.[isCraOrCraX]?.DateVE) ? formatDateJJMMYYYY(regularisation?.[isCraOrCraX]?.DateVC) : formatDateJJMMYYYY(regularisation?.[isCraOrCraX]?.DateVE),
                        'dateEmission': formatDateJJMMYYYY(regularisation?.dateEmission),
                        'Date':regularisation?.dateEmission, // champ spécifie le tri
                        'Statut': regularisation?.nbrUnite ? regularisation?.statutFacture : regularisation?.statutFactureX,
                        //'periode':regularisation?.[isCraOrCraX]?.month,
                        'periode':
                            dayjs(new Date(regularisation?.[isCraOrCraX]?.year, regularisation?.[isCraOrCraX]?.month-1)).locale('fr').format('MMMM YYYY'),
                        'dateEcheance':formatDateJJMMYYYY(moment(regularisation?.dateEmission).add('days',regularisation?.delaiPaiement)),
                        // 'dateEcheance':formatDateJJMMYYYY(moment(getLastWorkingDayOfMonth(
                        //     dayjs(new Date(regularisation?.[isCraOrCraX]?.year, regularisation?.[isCraOrCraX]?.month-1)).locale('fr').format('YYYY'),
                        //     dayjs(new Date(regularisation?.[isCraOrCraX]?.year, regularisation?.[isCraOrCraX]?.month-1)).locale('fr').format('MM'),
                        //     (regularisation?.[isCraOrCraX]?.missionId?.companyDataId?.profileEntreprise?.localisation?.split('/')?.pop()||'fr'))).add('days',regularisation?.delaiPaiement)),
                        'statutPaiementExpert':i18n.t(searchLabelInEnumByValue(statutPaiementEnum,regularisation?.statutPaimentExpert)),
                        'nbJour':regularisation?.nbrUnite,
                        'tjExpert':regularisation?.[isCraOrCraX]?.tj,
                        'tvaExpert': regularisation?.tva,
                        'datePaiementExpert':regularisation?.datePaimentExpert,
                        'totalAstreinte':regularisation?.totalAstreintes??'--',
                        'totalHnoClient':regularisation?.totalHnosClient??'--',
                        'totalHnoExpert': regularisation?.totalHnos??'--',
                        'totalNotesFrais': regularisation?.totalNotesFrais??'--',
                        'totalHTExpert':regularisation?.montantTotal,

                        'hnos':regularisation?.hnos,
                        'astreintes':regularisation?.astreintes,
                        'notesFrais':regularisation?.notesFrais,

                        'respOperationnel':getNomPrenomClearFromPersoData(regularisation?.[isCraOrCraX]?.bdcId?.responsableOperationnelId?.persoData ?? regularisation?.[isCraOrCraX]?.bdcId?.responsableOperationnelEsnId?.persoData),
                        'chargeRecrutement':getNomPrenomClearFromPersoData(regularisation?.[isCraOrCraX]?.bdcId?.backOfficeId?.persoData),
                        'Commercial':getNomPrenomClearFromPersoData(regularisation?.[isCraOrCraX]?.bdcId?.collaboratorEsnExpertId?.persoData),
                        ...regularisation
                    });
                });
            }
            setFactureRows(Array1);
            setFactureRows(sortDate(Array1));
        } catch (error) {
            console.log(error);
        }
        setBackdropOpen(false);
    };

    return (
        <>
            {role === 'esn'
                ? (
                    <div className='frame5Profile'>
                        {i18n.t('CRA & Factures')}
                        &gt;
                        <span style={{ color: '#B0B0B0' }}>{i18n.t('Vente')}</span>
                        &gt;
                        <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Factures')}</span>
                    </div>
                )
                : (
                    <div className='frame5Profile'>
                        {i18n.t('CRA & Factures')}
                        &gt;
                        <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Factures')}</span>
                    </div>
                )
            }
            <div className='HomeFrame'>
                <div style={{display:'flex',flexDirection:'row',alignSelf:'stretch',justifyContent:'space-between'}}>
                    <h4 className='titlesociete'>
                        {i18n.t('Factures')}
                    </h4>
                </div>
                <HeaderAllFacture />
                <MaterialTableComponent
                    title={i18n.t('Factures')}
                    data={factureRows}
                    columns={factureColumns4Expert}
                    onRowClick={(event, rowData) => {
                        setSelectedRow(rowData?.tableData.id);
                        setRowSelected(rowData);
                        setOpen(true);
                    }}
                    selectedRow={selectedRow}
                />
            </div>
            {open &&
            <Facture
                handleClose={()=>{
                    setOpen(false);
                }}
                facture={rowselected}
                open={open}
                role={'expert'}
                regularisation={'true'}
            />}
        </>
    );
};

export default AllRegularisationExpert;
